export const zIndex = {
  lv0: 1,
  lv1: 10,
  lv2: 20,
  lv3: 30,
  lv4: 40,
  lvMax: 50,
};
